<div class="modal-header">
  <h3 class="mb-0">Update Client Logo</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="cancel()"
  ></button>
</div>

<div class="modal-body">
  <app-file-upload-file-display
    [layout]="'vertical'"
    [Files]="Files"
    [hideSelectFileButton]="true"
    (FileEvent)="fileUpload($event)"
    (removeFileEvent)="removeFile($event)"
  ></app-file-upload-file-display>
</div>

<div class="modal-footer">
  <div class="action-row justify-end w-100">
    <button type="button" class="btn btn-ghost" (click)="cancel()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary" (click)="continue()">
      Submit
    </button>
  </div>
</div>
